import axios from "axios";
import { tokenBlacklistService } from "../helpers/tokenSecurity";
import { cacheUtils } from "../helpers/cacheUtils";

const URL = process.env.REACT_APP_USER_API;

export async function authenticate(forceLogin = false) {
  console.log('authenticate called with forceLogin:', forceLogin);
  let url = URL + "/authenticate";
  console.log('authenticate URL:', url);
  
  const token = sessionStorage.getItem('Token');
  if (!token) {
    console.error('No token found in sessionStorage');
    return { success: false, error: 'No authentication token' };
  }
  
  try {
    let response = await axios.post(url, { forceLogin }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      timeout: 10000,
      validateStatus: function (status) {
        return status < 500;
      }
    });
    
    console.log('authenticate response status:', response.status);
    console.log('authenticate response data:', response.data);
    
    // Handle concurrent session (409 status)
    if (response.status === 409) {
      console.log('Concurrent session detected, returning hasActiveSession: true');
      return { 
        success: false,
        error: 'concurrent_session',
        hasActiveSession: true,
        sessionId: response.data?.sessionId
      };
    }
    
    // Handle other error statuses
    if (response.status >= 400) {
      console.log('Authentication failed with status:', response.status);
      return { 
        success: false, 
        error: response.data?.message || `Authentication failed with status ${response.status}` 
      };
    }
    
    // Success case
    console.log('Authentication successful');
    return { ...response.data, success: true };
  } catch (error) {
    console.log('Authenticate error:', error);
    if (error.response?.status === 409) {
      console.log('Concurrent session detected in catch block');
      return { 
        success: false,
        error: 'concurrent_session',
        hasActiveSession: true,
        sessionId: error.response.data?.sessionId
      };
    }
    return { success: false, error: error.message };
  }
}

export async function logout() {
  try {
    const token = sessionStorage.getItem('Token');
    let url = URL + "/logout";
    
    await axios.post(url, { token });
    
    if (token) {
      tokenBlacklistService.addToBlacklist(token);
    }
    
    return { success: true };
  } catch (error) {
    console.error('Logout API error:', error);
    const token = sessionStorage.getItem('Token');
    if (token) {
      tokenBlacklistService.addToBlacklist(token);
    }
    return { success: false, error };
  }
}

export async function getAllUsers() {
  let url = URL + "/getusers";
  console.log('getAllUsers called, URL:', url);
  
  try {
    let response = await axios.post(url, {}, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log('getAllUsers response:', response.status, response.data?.length || 0, 'users');
    return response.data;
  } catch (error) {
    console.error('getAllUsers error details:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      code: error.code
    });
    throw error;
  }
}

export const addNewUser = async (user) => {
  let url = `${URL}/adduser`;
  const response = await axios.post(url, user);
  return response.data;
};

export const updateUser = async (payload) => {
  let url = `${URL}/updateuser`;
  const response = await axios.post(url, payload);
  return response.data;
};
